/**
 * =============================================================================
 * cookie-bar.js
 * =============================================================================
 * Simple accept cookie bar
 * =============================================================================
 */

 var CookieBar = {
  selectors: {
    bar: "#static-cookie-bar",
    agree_button: "#static-cookie-bar button"
  },

  /**
   * Check if agreed - if not, show the bar
   */
  init: function(){
    var notAgreed = Cookies.get('cookies-agreed') === undefined;
    if(notAgreed){
      let bar = document.querySelector(this.selectors.bar);
      if(!bar){
        return;
      }
      let agreeButton = document.querySelector(this.selectors.agree_button);
      bar.classList.remove("d-none");
      agreeButton.addEventListener("click", this.handleAgreement.bind(this));
    }
  },

  /**
   * Hide the bar once agreed, and set a cookie to prevent showing in future
   */
  handleAgreement: function() {
    let bar = document.querySelector(this.selectors.bar);
    bar.classList.add('fade-out');
    bar.onanimationend = () => { bar.classList.add("d-none"); };
    Cookies.set('cookies-agreed', "true");
  }
};

export default CookieBar;